import { render, staticRenderFns } from "./AddEditAdvance.vue?vue&type=template&id=2a004454&scoped=true"
import script from "./AddEditAdvance.vue?vue&type=script&lang=js"
export * from "./AddEditAdvance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a004454",
  null
  
)

export default component.exports